<template>
    <div>
        <form class="w-full h-full lg:h-screen flex items-center justify-center"
              @submit.prevent="handleSubmit"
              @keydown.enter.prevent="checkIfCompanyExists"
        >
            <!-- TODO: removed this for the temp rework of the free trial (don't need handleSubmit)-->
<!--              @keydown.enter.prevent="step === 1 ? checkIfCompanyExists : handleSubmit"-->
<!--              :class="step === 1 ? 'items-center justify-center' : ''"
        > -->
            <!-- Temp new flow -->
            <div class="md:flex align-top w-full max-w-1440 mx-auto">
                <div class="w-full mx-auto md:w-1/2 lg:w-1/3 text-center my-auto">
                    <div
                        class="mx-16 md:mx-0"
                        :class="{'md:mt-24 md:shadow-md lg:shadow-none rounded-6 pb-18 px-24 bg-white': step === 2}"
                    >
                        <h1 class="block text-heading-1 lg:text-big font-semibold text-primary-80 leading-none mb-12"
                            v-html="regionTrialTitle"/>
                        <p v-if="step === 1" class="mx-auto" v-html="$t('auth.register_subtitle')"/>
                        <p v-else class="mx-auto" v-html="$t('auth.register_requested_subtitle')"/>
                    </div>
                    <div v-if="step === 1" class="mt-24 md:shadow-md rounded-6 py-18 px-24 bg-white">
                        <div class="space-y-8 md:space-y-16 text-left">
                            <div class="mb-8 md:mb-16 flex flex-col md:flex-row flex-wrap gap-8 md:gap-16 w-full">
                                <simple-input
                                    v-model="form.first_name"
                                    :errors="form.errors.first_name"
                                    :required="true"
                                    placeholder="John"
                                    type="text"
                                    class="flex-1"
                                >
                                    {{ $t('auth.your_first_name') }}*
                                </simple-input>
                                <simple-input
                                    v-model="form.last_name"
                                    :errors="form.errors.last_name"
                                    :required="true"
                                    placeholder="Doe"
                                    type="text"
                                    class="flex-1"
                                >
                                    {{ $t('auth.your_last_name') }}*
                                </simple-input>
                            </div>
                            <simple-input
                                v-model="form.company_name"
                                :errors="form.errors.company_name"
                                :required="true"
                                placeholder="John Doe Inc."
                                class="mb-16 w-full" type="text"
                                @input-blur="handleInputChange($event, 'company_name')"
                            >
                                {{ $t('company.name') }}*
                            </simple-input>
                            <simple-input v-model="form.email"
                                          :errors="form.errors.email"
                                          class="mb-16 first-letter:uppercase w-full"
                                          placeholder="john.doe@example.com"
                                          type="email"
                                          :required="true"
                            >
                                {{ $t('auth.your_business_email') }}*
                            </simple-input>
                            <div class="flex flex-wrap w-full space-y-4">
                                <label class="text-body-sm flex items-center w-full">
                                    <span class="first-letter:uppercase  font-semibold text-black">
                                        {{ $t('company.human_resources.phone') }}*
                                    </span>
                                </label>
                                <p v-if="form.errors.phone" class="block text-semantic-error">
                                    <span class="inline-flex items-center gap-4">
                                        <svg-icon
                                            type="error"
                                            class="w-16 h-16"
                                        />
                                        <span class="text-body-sm">{{ form.errors.phone[0] }}</span>
                                    </span>
                                </p>
                                <VueTelInput
                                        :class="form.errors.phone ? 'error' : ''"
                                        styleClasses="w-full rounded border-primary-80 has-[:focus]:border-semantic-info h-full pl-8 pr-8 bg-white"
                                        :inputOptions="{type: 'tel', name: 'telephone', maxlength: 25, showDialCode: false, styleClasses: 'py-12 pr-16', placeholder: $t('applications.phone')}"
                                        :dropdownOptions="{showFlags: true, showDialCodeInList: true, showDialCodeInSelection: true}"
                                        :preferred-countries="['BE', 'NL', 'DE', 'FR', 'GB']"
                                         defaultCountry="BE"
                                         mode="international"
                                         :autoDefaultCountry="false"
                                         :validCharactersOnly="true"
                                         @on-input="updatePhone"
                                         @country-changed="updateCountry"
                                         required
                                />
                            </div>
                        </div>

                        <checkbox
                            v-model="form.accepted_terms"
                            class="w-full flex justify-center bg-white rounded-6 mt-20 md:mt-32"
                            @change="handleInputChange($event, 'accepted_terms')"
                        >
                            <div class="first-letter:uppercase text-left text-body-sm leading-none font-normal" v-html="
                            $t('register.accept_terms_and_conditions', {
                                terms_of_use: this.buildUrl(
                                    $t('auth.terms'),
                                    $t('auth.terms_of_use')
                                ),
                                privacy_policy: this.buildUrl(
                                    $t('auth.privacy_policy_slug'),
                                    $t('auth.privacy_policy')
                                ),
                            })"/>
                        </checkbox>
                        <p v-if="form.errors.accepted_terms" class="text-semantic-error text-left mt-4 text-body-sm">
                            {{ form.errors.accepted_terms[0] }}
                        </p>

                        <simple-button
                            :loading="submitting"
                            :uppercase="false"
                            class="w-full mt-32"
                            display="primary"
                            @click="checkIfCompanyExists"
                            type="button">
                            {{ $t('auth.register_submit') }}
                        </simple-button>
                    </div>
                    <div v-if="step !== 2" class="text-center md:text-start py-16 text-body-sm w-full">
                        <p @click="gotoLogin">
                            <span> {{ $t('auth.already_use_jobtoolz') }}</span>
                            <button class="text-primary-60"
                                    role="button"
                                    type="button"
                            >
                                {{ $t('auth.login') }}
                            </button>
                        </p>
                    </div>
                </div>
                <div class="hidden lg:flex md:w-1/2 md:items-center mt-48 md:mt-0">
                    <div ref="swiper" class="swiper">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide text-center">
                                <div class="mx-auto">
                                    <img src="/app/img/register/register-slide1.svg" alt=""
                                         class="inline-block">
                                    <div class="hidden mt-12 md:block">
                                        <h2 class="inline-block text-heading-2 mt-12 leading-none font-semibold">
                                            {{ $t('register.employer_branding_title') }}
                                        </h2>
                                    </div>
                                    <p class="mt-12 hidden md:block">
                                        {{ $t('register.employer_branding_content') }}
                                    </p>
                                </div>
                            </div>
                            <div class="swiper-slide text-center">
                                <div class="mx-auto">
                                    <img src="/app/img/register/register-slide2.svg" alt=""
                                         class="inline-block">
                                    <div class="hidden mt-12 md:block">
                                        <h2 class="inline-block text-heading-2 mt-12 leading-none font-semibold">
                                            {{ $t('register.recruitment_marketing_title') }}
                                        </h2>
                                    </div>
                                    <p class="mt-12 hidden md:block">
                                        {{ $t('register.recruitment_marketing_content') }}
                                    </p>
                                </div>
                            </div>
                            <div class="swiper-slide text-center">
                                <div class="mx-auto">
                                    <img src="/app/img/register/register-slide3.svg" alt=""
                                         class="inline-block">
                                    <div class="hidden mt-12 md:block">
                                        <h2 class="inline-block text-heading-2 mt-12 leading-none font-semibold">
                                            {{ $t('register.ats_title') }}
                                        </h2>
                                    </div>
                                    <p class="mt-12 hidden md:block">
                                        {{ $t('register.ats_content') }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="swiper-pagination mt-24 relative hidden md:block"></div>
                    </div>
                </div>
            </div>
            <!-- TODO: temporarily removed due to free trial breach, when all measures are taken, this should get re-implemented -->
<!--        <div v-if="step === 1" class="md:flex align-top w-full max-w-1440 mx-auto">
                <div class="w-3/4 mx-auto md:w-1/3 text-center">
                    <h1 class="block text-heading-1 lg:text-big font-semibold text-primary-80 leading-none mb-12"
                        v-html="regionTrialTitle"/>
                    <p class="md:max-w-[70%] mx-auto" v-html="$t('auth.register_subtitle')"/>
                    <div class="mt-24 md:mx-32">
                        <div class="space-y-16 text-left">
                            <simple-input v-model="form.email"
                                          :errors="form.errors.email"
                                          class="mb-16 first-letter:uppercase w-100"
                                          placeholder="john.doe@example.com"
                                          type="email"
                                          :required="true"
                            >
                                {{ $t('auth.your_business_email') }} *
                            </simple-input>
                            <simple-input v-model="form.company_name" :errors="form.errors.company_name"
                                          :required="true"
                                          class="mb-16 w-100" type="text"
                                          @input-blur="handleInputChange($event, 'company_name')"
                            >
                                {{ $t('company.name') }} *
                            </simple-input>
                            <simple-input v-model="form.password" :errors="form.errors.password"
                                          :required="true"
                                          class="mb-16 w-100"
                                          type="password"
                                          @input-blur="handleInputChange($event, 'password')"
                            >
                                {{ $t('auth.your_password') }} *
                            </simple-input>
                        </div>

                        <checkbox
                            v-model="form.accepted_terms"
                            class="w-full flex justify-center bg-white rounded-6 mt-20 md:mt-32"
                            @change="handleInputChange($event, 'accepted_terms')"
                        >
                            <div class="first-letter:uppercase text-left text-body-sm leading-none font-normal" v-html="
                            $t('register.accept_terms_and_conditions', {
                                terms_of_use: this.buildUrl(
                                    $t('auth.terms'),
                                    $t('auth.terms_of_use')
                                ),
                                privacy_policy: this.buildUrl(
                                    $t('auth.privacy_policy_slug'),
                                    $t('auth.privacy_policy')
                                ),
                            })"/>
                        </checkbox>
                        <p v-if="form.errors.accepted_terms" class="text-semantic-error text-left mt-4 text-body-sm">
                            {{ form.errors.accepted_terms[0] }}
                        </p>

                        <simple-button
                            :loading="submitting"
                            :uppercase="false"
                            class="mt-32 font-semibold w-full rounded-32 text-white px-24 py-16 text-body leading-none bg-secondary hover:text-primary-80"
                            display="none"
                            @click="checkIfCompanyExists"
                            type="button">
                            {{ $t('auth.register_submit') }}
                        </simple-button>

                        <div class="text-center justify-center mt-16 text-body-sm w-full">
                            <p class="flex justify-center items-center space-x-8">
                                <span> {{ $t('auth.already_use_jobtoolz') }}</span>
                                <button class="text-primary-60"
                                        role="button"
                                        type="button"
                                        @click="gotoLogin">
                                    {{ $t('auth.login') }}
                                </button>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="w-full md:flex md:w-1/2 md:items-center mt-48 md:mt-0">
                    <div ref="swiper" class="swiper">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide text-center">
                                <div class="mx-auto">
                                    <img src="/app/img/register/register-slide1.svg" alt=""
                                         class="inline-block">
                                    <div class="hidden mt-12 md:block">
                                        <h2 class="inline-block text-heading-2 mt-12 leading-none font-semibold">
                                            {{ $t('register.employer_branding_title') }}
                                        </h2>
                                    </div>
                                    <p class="mt-12 hidden md:block">
                                        {{ $t('register.employer_branding_content') }}
                                    </p>
                                </div>
                            </div>
                            <div class="swiper-slide text-center">
                                <div class="mx-auto">
                                    <img src="/app/img/register/register-slide2.svg" alt=""
                                         class="inline-block">
                                    <div class="hidden mt-12 md:block">
                                        <h2 class="inline-block text-heading-2 mt-12 leading-none font-semibold">
                                            {{ $t('register.recruitment_marketing_title') }}
                                        </h2>
                                    </div>
                                    <p class="mt-12 hidden md:block">
                                        {{ $t('register.recruitment_marketing_content') }}
                                    </p>
                                </div>
                            </div>
                            <div class="swiper-slide text-center">
                                <div class="mx-auto">
                                    <img src="/app/img/register/register-slide3.svg" alt=""
                                         class="inline-block">
                                    <div class="hidden mt-12 md:block">
                                        <h2 class="inline-block text-heading-2 mt-12 leading-none font-semibold">
                                            {{ $t('register.ats_title') }}
                                        </h2>
                                    </div>
                                    <p class="mt-12 hidden md:block">
                                        {{ $t('register.ats_content') }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="swiper-pagination mt-24 relative hidden md:block"></div>
                    </div>
                </div>
            </div>
            <div v-else>
                <nav class="h-screen bg-primary hidden md:flex flex-col w-72 items-center fixed z-90">
                    <div class="pt-16 mb-12 border-b-2 border-primary-80 flex-none">
                        <div class="flex mb-16">
                            <svg-icon type="logo-white" class="w-40 h-40"></svg-icon>
                        </div>
                    </div>
                    <help-link/>
                </nav>
                <div class="md:pl-72 bg-primary-5 h-screen w-screen flex flex-col">
                    <div class="hidden md:block bg-white h-72 shadow-sm z-100"></div>
                    <div id="content-container" class="px-16 md:px-32 flex flex-grow items-center justify-center  ">
                        <div class="bg-white rounded-6 shadow-md w-full px-16 md:px-48 py-32 text-center"
                             style="max-width: 550px">
                            <lottie-animation
                                class="mb-12 md:my-12 md:my-24 md:w-1/2 mx-auto"
                                :autoPlay="true"
                                :loop="true"
                                :animationData="animationData"
                                :key="animationKey"
                            />
                            <div v-if="!loading">
                                <h1 class="font-semibold text-heading-2">
                                    {{ $t('free_trial.welcome') }}
                                </h1>
                                <p class="font-light" v-html="$t('register.company_tagline')"/>
                                <div class="mt-24 flex-wrap flex items-center justify-center">
                                    <div class="md:flex w-full md:space-x-32 mb-12 text-left">
                                        <simple-input v-model="form.first_name" :errors="form.errors.first_name"
                                                      class="md:w-1/2 mb-16 md:mb-0" type="text">
                                            {{ $t('auth.your_first_name') }}
                                        </simple-input>

                                        <simple-input v-model="form.last_name" :errors="form.errors.last_name"
                                                      class="md:w-1/2" type="text">
                                            {{ $t('auth.your_last_name') }}
                                        </simple-input>
                                    </div>

                                    <div class="flex flex-wrap w-full">
                                        <label class="mb-8 text-body-sm flex items-center">
                                        <span class="first-letter:uppercase">
                                            {{ $t('company.human_resources.phone') }}:
                                        </span>
                                        </label>
                                        <VuePhoneNumberInput v-model="form.phone"
                                                             :class="form.errors.phone ? 'error' : ''"
                                                             :fetch-country="true"
                                                             :no-use-browser-locale="true"
                                                             :preferred-countries="['BE', 'NL', 'DE', 'FR']"
                                                             :translations="{
                                                                          countrySelectorLabel: '',
                                                                          countrySelectorError: $t('auth.choose_country'),
                                                                          phoneNumberLabel: $t('applications.phone'),
                                                                          example: ''}"
                                                             class="w-full"
                                                             no-example
                                                             show-code-on-list
                                                             @update="updatePhone"
                                        />
                                        <p v-if="form.errors.phone" class="text-semantic-error text-body-sm">
                                            {{ form.errors.phone[0] }}
                                        </p>
                                    </div>

                                    <div class="text-center">
                                        <simple-button
                                            :loading="submitting"
                                            :uppercase="false"
                                            class="mt-16 font-semibold rounded-32 text-white px-48 py-16 text-body leading-none bg-secondary hover:text-primary-80 inline-block"
                                            display="none"
                                            @click="handleSubmit"
                                            type="button">
                                            {{ $t('register.launch') }}
                                        </simple-button>
                                        <span class="text-primary-60 cursor-pointer block mt-8" @click="step = 1">
                                            {{ $t('register.back') }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <p>{{ loadingText }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>-->
        </form>
    </div>
</template>

<script>
import {mapState, mapActions, mapStores} from 'pinia';
import {useMainStore} from '../state/store';
import {useAuthenticationStore} from '../state/modules/authentication';
import {useNotificationsStore} from '../state/modules/notifications';
import Form from '../etc/forms/Form';
import values from 'lodash/values';
import flatten from 'lodash/flatten';
import Input from '../components/forms/Input.vue';
import Checkbox from '../components/forms/Checkbox.vue';
import SimpleButton from '../components/ui/SimpleButton.vue';

import { VueTelInput } from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';

import SelectDropdown from '../components/forms/SelectDropdown';
import SvgIcon from "../components/ui/SvgIcon.vue";
import {validateCompany} from '../services/UserService';
import {ADD_NOTIFICATION} from '../state/mutation-types';

import Swiper, {Autoplay, Pagination} from 'swiper'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import HelpLink from "../components/HelpLink.vue";

import {LottieAnimation} from "lottie-web-vue";
import animationWelcome from '../../../../../public/app/animations/welcome.json';
import animationLoading from '../../../../../public/app/animations/loading.json';

export default {
    name: 'Register',
    components: {
        LottieAnimation,
        HelpLink,
        SvgIcon,
        SelectDropdown,
        'simple-button': SimpleButton,
        'checkbox': Checkbox,
        'simple-input': Input,
        VueTelInput,
    },
    head() {
        return {
            title: this.$t('auth.register'),
        };
    },
    data: function () {
        return {
            animationWelcome,
            animationLoading,
            submitting: false,
            step: 1,
            form: new Form([
                {name: 'email', value: null, rules: ['required']},
                {name: 'first_name', value: '', rules: ['required']},
                {name: 'last_name', value: '', rules: ['required']},
                {name: 'company_name', value: null, rules: ['required']},
                {name: 'phone', value: null, rules: ['required']},
                {name: 'phone_formatted', value: ''},
                {name: 'country', value: 'BE', rules: ['required']},
                {name: 'accepted_terms', value: false},
                // TODO: re-add when free trial is re-implemented
                // {name: 'password', value: '', rules: ['required']},
            ]),
            loadingTextIndex: 0,
            loadingInterval: null,
            resultsExample: null,
            loading: false,
            animationKey: 0,
        };
    },
    computed: {
        ...mapState(useMainStore, ['locale']),
        ...mapStores(useAuthenticationStore),
        hasErrors() {
            return values(this.form.errors).some(errors => errors !== undefined);
        },
        allErrors() {
            return flatten(values(this.form.errors).filter(error => error && error.length));
        },
        loadingText() {
            return this.$rt(this.$tm('auth.register_cycle_words')[this.loadingTextIndex]);
        },
        countries() {
            return Object.keys(this.$tm('countries')).map((key) => ({
                label: this.$rt(this.$tm('countries')[key]),
                value: key,
            })).concat([{
                label: '--- Select country ---',
                value: null,
            }]);
        },
        animationData() {
            return this.loading ? this.animationLoading : this.animationWelcome;
        },
        regionTrialTitle() {
            if (this.step === 1) {
                if (Jobtoolz.region === 'AU') {
                    return this.$t('auth.register_title_AU');
                } else {
                    return this.$t('auth.register_title');
                }
            } else {
                return this.$t('auth.register_requested_title');
            }
        },
    },
    methods: {
        ...mapActions(useNotificationsStore, [ADD_NOTIFICATION]),
        checkIfCompanyExists() {
            this.submitting = true;
            this.form.submit(() => {
                return validateCompany({
                    data: {
                        attributes: this.form.data
                    }
                });
            }).then(() => {
                this.step = 2;
            }).catch((error) => {
                if (error.response.status !== 422) {
                    this[ADD_NOTIFICATION]({
                        type: 'error',
                        message: error.response.data.message,
                    });
                }
            }).finally(() => {
                this.submitting = false;
            });
        },
        handleSubmit() {
            // TODO: this code won't execute until the free trial is re-implemented
            this.startLoadingTexts();
            this.submitting = true;
            this.loading = true;
            this.animationKey++;

            this.form.submit(() => {
                return this.authenticationStore.register(this.form.data);
            }).then((response) => {
                window.dataLayerJT.push({'event': 'successful-registration'});

                return this.authenticationStore.login({
                    data: {
                        email: this.form.data.email,
                        password: this.form.data.password,
                        remember: this.form.data.remember,
                    }
                });
            }).then(() => {
                setTimeout(() => {
                    //instead go to free trial
                    this.$router.push({name: 'free-trial'});
                }, 1);
            }).finally(() => {
                this.submitting = false;

                if (this.loadingInterval) {
                    clearInterval(this.loadingInterval);
                }
            });

        },
        handleInputChange(value, input) {
            if (value) {
                this.form.errors[input] = null;
            }
        },
        handleReset() {
            this.form.reset();
        },
        gotoLogin() {
            this.$router.push({name: 'login'});
        },
        startLoadingTexts() {
            this.loadingTextIndex = 0;
            this.loadingInterval = setInterval(() => this.loadingTextIndex++, 10000);
        },
        updatePhone(number, numberObject) {
            this.form.phone = numberObject.nationalNumber;
            this.form.phone_formatted = number;
        },
        updateCountry(country) {
            this.form.country = country.iso2;
        },
        buildUrl(url, label) {
            const urlLocale = this.locale || 'en'
            return `<a href="https://jobtoolz.com/${urlLocale}/${url}" class="text-primary-60 hover:text-secondary" target="_blank">${label}</a>`;
        }
    },
    watch: {
        // TODO: re-add when free trial is re-implemented
        // 'step'(value) {
        //     document.querySelector('.logo').classList[value === 2 ? 'add' : 'remove']('hidden')
        // }
    },
    mounted() {
        new Swiper(this.$refs.swiper, {
            modules: [
                Pagination,
                Autoplay
            ],
            loop: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: true
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                bulletClass: 'swiper-pagination-bullet opacity-100 bg-primary-20',
                bulletActiveClass: 'bg-primary-80',
            },
        })
    },
};
</script>

<style>
.input-tel label {
    display: none !important;
}

.input-tel input {
    padding-top: 0 !important;
}
</style>

<style scoped>

/* Blue background circlw */
form::before {
    content: '';
    bottom: -30%;
    width: 105%;
    height: 45%;
    display: inline-block;
    border-radius: 50%;
    background-color: #DBE0FB;
    position: absolute;
    z-index: -10;
}

.swiper-slide img {
    height: 140px;
    margin-bottom: 48px;
}

@media only screen and (max-width: 768px) {
    form::before {
        display: none !important;
    }
}

@media only screen and (max-width: 1024px) {
    form::before {
        display: block;
        width: 150dvw;
        height: 150dvw;
        top: 50%;
        left: 50%;
        transform: translateX(-50%);
    }
}

@media only screen and (min-width: 1024px) {
    form::before {
        bottom: auto;
        height: 125%;
        right: -15%;
        width: 66%;
    }

    .swiper-slide img {
        height: 350px;
        margin-bottom: 0;
    }

    .swiper {
        max-width: 90%;
    }
}

/*@media screen and (min-width: 1024px) {
    form::before {
        bottom: -30%;
        width: 105%;
        height: 45%;
    }

    .swiper-slide img {
        height: 350px;
        margin-bottom: 0;
    }

    .swiper {
        max-width: 90%;
    }
}*/
</style>
